// components/ui/AnimatedBackground.jsx
import React from 'react';
import { Box } from '@mui/material';

export const AnimatedBackground = () => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: -1,
        overflow: 'hidden',
      }}
    >
      {/* Animated circles */}
      <Box
        sx={{
          position: 'absolute',
          top: '10%',
          left: '10%',
          width: 200,
          height: 200,
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(139, 0, 0, 0.1) 0%, transparent 70%)',
          animation: 'float 6s ease-in-out infinite',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: '20%',
          right: '15%',
          width: 300,
          height: 300,
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(255, 77, 77, 0.05) 0%, transparent 70%)',
          animation: 'float 8s ease-in-out infinite 1s',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '20%',
          width: 150,
          height: 150,
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(139, 0, 0, 0.08) 0%, transparent 70%)',
          animation: 'float 7s ease-in-out infinite 0.5s',
        }}
      />
    </Box>
  );
};

